export const VideoPage_Data = {
    "luzon-blinds": {

        // Page Meta Fields
        META_PG_Title: 'Luzon Blinds | Marvel Blinds',
        OG_title: 'Luzon Blinds',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}/videos/luzon-blinds/`,

        VID_Col1_title: "Product",
        VID_embed_src: "https://www.youtube.com/embed/zDLrxvN5r4w?si=kwIrKxl50MTD4mJ-",
        VID_info_title: "Luzon Blinds",
        VID_info_dec: "Marvel Luzon Blinds combine alternating sheer and solid fabric bands in a single shade. Stunningly eye catching stripes features the ideal balance of Light and Privacy for your window Furnishings designs and create the perfect look for your interiors.",
        VID_Suggestions: 1,
        VID_Current_index: 1,
    },
    "colby-blinds-by-Marvel-window-fashion": {

        // Page Meta Fields
        META_PG_Title: 'Colby Blinds by Marvel Window Fashion | Marvel Blinds',
        OG_title: 'Colby Blinds by Marvel Window Fashion',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}/videos/colby-blinds-by-Marvel-window-fashion/`,

        VID_Col1_title: "Product",
        VID_embed_src: "https://www.youtube.com/embed/-U1mVUFPRPI?si=XIClCILCqoxqIPSO",
        VID_info_title: "Colby Blinds by Marvel Window Fashion",
        VID_info_dec: "Most energy efficient blinds specifically engineered to provide beauty and Luxury Marvel Colby blind combines soft, seamless fabrics with crisp uniform pleats that hold the shape indefinitely. Choose Top-down / Bottom-up and open your shades from the top, bottom, or both. While Choosing Day & Night Control Light as you desire.",
        VID_Suggestions: 1,
        VID_Current_index: 2,
    },
    "marvel-panel-blinds": {

        // Page Meta Fields
        META_PG_Title: 'Marvel Panel Blinds | Marvel Blinds',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}/videos/marvel-panel-blinds/`,
        OG_title: 'Marvel Panel Blinds',

        VID_Col1_title: "Product",
        VID_embed_src: "https://www.youtube.com/embed/xRPviMwjlSw?si=JGj1WlwbzVLaYoCW",
        VID_info_title: "Marvel Panel Blinds",
        VID_info_dec: "Make a statement and enhance your space with Marvel Panel blinds Transform your space with contemporary Panel Blinds. Marvel Panel blinds offer a sleek answer for both large and small window expanses. Open, they stack compactly to offer the maximum view; closed, they display their rich fabrics, colour and texture. Panel blinds are an ideal choice for those who want to make an impact and add something a little different to their interior. With their flexible nature, not only do they make a lustrous window decoration for larger windows, bi-fold or patio doors, but they are a fantastic choice for room dividers as well. Dazzling choice of fabrics with 550+ awesome designs and colours",
        VID_Suggestions: 1,
        VID_Current_index: 3,
    },
    "new-window-nice": {

        // Page Meta Fields
        META_PG_Title: 'Grayson Blinds | Marvel Blinds',
        OG_title: 'Grayson Blinds',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}/videos/new-window-nice/`,

        VID_Col1_title: "Product",
        VID_embed_src: "https://www.youtube.com/embed/9nkFWJYdPuQ?si=2HL9Gsp7SZumTgRN",
        VID_info_title: "Grayson Blinds",
        VID_info_dec: "Marvel Grayson blinds gives you ultimate privacy with a view to the outside. It easily creates beautiful gradations of light like Venetian blinds with Soft fabric vanes suspended between two sheers, diffusing softened light deep into a room. Tilt the vanes to enjoy the lighting you desire.",
        VID_Suggestions: 1,
        VID_Current_index: 4,
    },
    "wooden-venetian": {

        // Page Meta Fields
        META_PG_Title: 'Wooden Venetian Blinds | Marvel Blinds',
        OG_title: 'Wooden Venetian Blinds',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}/videos/wooden-venetian/`,

        VID_Col1_title: "Product",
        VID_embed_src: "https://www.youtube.com/embed/EDF9WOHNw08?si=QU7YkGuvOPLOynj3",
        VID_info_title: "Wooden Venetian Blinds",
        VID_info_dec: "Add a contemporary feel to your Interiors with Marvel Wooden Venetian blinds and experience timeless luxury. Choose from a Unique collection of Faux Metallic & Natural Basswood series to complete the elegance of your home decor. With an array of ladder tape colours help define your Wooden Venetian design and add extra style to Window fashion.",
        VID_Suggestions: 1,
        VID_Current_index: 5,
    },
    "wooden-venetian-manual": {

        // Page Meta Fields
        META_PG_Title: 'Wooden Venetian Manual | Marvel Blinds',
        OG_title: 'Wooden Venetian Manual',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}/videos/wooden-venetian-manual/`,

        VID_Col1_title: "Operating System",
        VID_embed_src: "https://www.youtube.com/embed/EDF9WOHNw08?si=uXKoWuRgkGqAVsvo",
        VID_info_title: "Wooden Venetian Manual",
        VID_info_dec: "One of the most important advantages of Marvel window coverings is their ease of operation. A continuous ball chain loop works on the principle of a pulley, rotating a clutch to open or close the blind.",
        VID_Suggestions: 2,
        VID_Current_index: 1
    },
    "roller-blinds-one-touch-up": {

        // Page Meta Fields
        META_PG_Title: 'Roller Blinds One Touch Up | Marvel Blinds',
        OG_title: 'Roller Blinds One Touch Up',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}/videos/roller-blinds-one-touch-up/`,

        VID_Col1_title: "Operating System",
        VID_embed_src: "https://www.youtube.com/embed/SdX-ARTzw-c?si=rNrOMPLSusCBKfH_",
        VID_info_title: "Roller Blinds One Touch Up",
        VID_info_dec: "One Touch Up is a smart system wherein you just need to pull the operating cord, and the blind will roll up on its own.",
        VID_Suggestions: 2,
        VID_Current_index: 2
    },
    "colby-blinds-top-down-bottom-up-tdbu": {

        // Page Meta Fields
        META_PG_Title: 'Colby Blinds Top Down Bottom Up (TDBU) | Marvel Blinds',
        OG_title: 'Colby Blinds Top Down Bottom Up (TDBU)',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}/videos/colby-blinds-top-down-bottom-up-tdbu/`,

        VID_Col1_title: "Operating System",
        VID_embed_src: "https://www.youtube.com/embed/oZFSGH7GASM?si=foBGWUyvKY7fY2MY",
        VID_info_title: "Colby Blinds Top Down Bottom Up (TDBU)",
        VID_info_dec: "Marvel Colby Blind Top-Down/Bottom-Up system offers you the ability to operate window blind from the top down or the bottom up to meet all your privacy needs while still giving you access to natural light.",
        VID_Suggestions: 2,
        VID_Current_index: 3
    },
    "patricia-blind-automation": {

        // Page Meta Fields
        META_PG_Title: 'Patricia Blind Automation | Marvel Blinds',
        OG_title: 'Patricia Blind Automation',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}/videos/patricia-blind-automation/`,

        VID_Col1_title: "Operating System",
        VID_embed_src: "https://www.youtube.com/embed/M-90o7MVyug?si=WuDNPCAVl4RrP-HQ",
        VID_info_title: "Patricia Blind Automation",
        VID_info_dec: "The Remote Control allows you to preset and easily operate a group of up to sixteen different window blinds, individually or together with just a press of a button. Remote Controls can also be affixed to a wall.",
        VID_Suggestions: 2,
        VID_Current_index: 4
    },
}